export default "__VITE_ASSET__B63xA2U___"